import { render, staticRenderFns } from "./myCreated.vue?vue&type=template&id=dc8defd8&scoped=true&lang=pug"
import script from "./myCreated.vue?vue&type=script&lang=js"
export * from "./myCreated.vue?vue&type=script&lang=js"
import style0 from "./myCreated.vue?vue&type=style&index=0&id=dc8defd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8defd8",
  null
  
)

export default component.exports